export default __webpack_public_path__ + "static/media/storm.a74981e8.png";